<template>
  <v-flex
    id="barriers"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheetOne.hint') }}
    </p>
    <h2 class="display-3 display-3_dark">
      {{ getFamilyBarriersQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getFamilyBarriersQuestions.hasOwnProperty('need_the_most')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyBarriersQuestions.need_the_most.required }"
        >
          {{ getFamilyBarriersQuestions.need_the_most.label }}
          <span
            v-if="!getFamilyBarriersQuestions.need_the_most.required"
            class="optional-text"
          >
            {{ $t('message.optional') | brackets }}</span>
        </p>
        <v-textarea
          v-model="needTheMost"
          v-validate="{ ...regularLongText(getFamilyBarriersQuestions.need_the_most.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('regular_field_8')"
          data-vv-as=" "
          data-vv-name="regular_field_8"
          :required="getFamilyBarriersQuestions.need_the_most.required"
          :disabled="readOnly"
          auto-grow
        />
      </li>
      <li
        v-if="getFamilyBarriersQuestions.hasOwnProperty('work_on')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyBarriersQuestions.work_on.required }"
        >
          {{ getFamilyBarriersQuestions.work_on.label }}
          <span
            v-if="!getFamilyBarriersQuestions.work_on.required"
            class="optional-text"
          >
            {{ $t('message.optional') | brackets }}</span>
        </p>
        <v-textarea
          v-model="workOn"
          v-validate="{ ...regularLongText(getFamilyBarriersQuestions.work_on.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('regular_field_9')"
          data-vv-as=" "
          data-vv-name="regular_field_9"
          :required="getFamilyBarriersQuestions.work_on.required"
          :disabled="readOnly"
          auto-grow
        />
      </li>
      <li
        v-if="getFamilyBarriersQuestions.hasOwnProperty('need_others_help')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyBarriersQuestions.need_others_help.required }"
        >
          {{ getFamilyBarriersQuestions.need_others_help.label }}
          <span
            v-if="!getFamilyBarriersQuestions.need_others_help.required"
            class="optional-text"
          >
            {{ $t('message.optional') | brackets }}</span>
        </p>
        <v-textarea
          v-model="needOthersHelp"
          v-validate="{ ...regularLongText(getFamilyBarriersQuestions.need_others_help.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('needOthersHelp')"
          data-vv-as=" "
          data-vv-name="needOthersHelp"
          :required="getFamilyBarriersQuestions.need_others_help.required"
          :disabled="readOnly"
          auto-grow
        />
      </li>
      <li
        v-if="getFamilyBarriersQuestions.hasOwnProperty('pandemic')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyBarriersQuestions.pandemic.required }"
        >
          {{ getFamilyBarriersQuestions.pandemic.label }}
          <span
            v-if="!getFamilyBarriersQuestions.pandemic.required"
            class="optional-text"
          >
            {{ $t('message.optional') | brackets }}</span>
        </p>
        <v-textarea
          v-model="pandemic"
          v-validate="{ ...regularLongText(getFamilyBarriersQuestions.pandemic.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('pandemic')"
          data-vv-as=" "
          data-vv-name="pandemic"
          :required="getFamilyBarriersQuestions.pandemic.required"
          :disabled="readOnly"
          auto-grow
        />
      </li>
      <li
        v-if="getFamilyBarriersQuestions.hasOwnProperty('about_sixty')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyBarriersQuestions.about_sixty.required }"
        >
          {{ getFamilyBarriersQuestions.about_sixty.label }}
        </p>
        <ConfirmButtons
          v-model="aboutSixty"
          v-validate="{ required: getFamilyBarriersQuestions.about_sixty.required }"
          string
          :error-messages="errors.collect('aboutSixty')"
          data-vv-as=" "
          :disabled="readOnly"
          :data-vv-name="'aboutSixty'"
        />
      </li>
    </ul>
    <v-layout
      v-if="endButton != null"
      justify-center
      my-3
    >
      <v-flex shrink>
        <div>
          <v-btn
            color="sz_violet"
            :to="{ name: endButton.to }"
          >
            {{ endButton.text }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import filters from '@/constants/filters';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetSectionsVisibility from '@/mixins/sheet/sheetSectionsVisibility';

import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getBarriersField',
    mutationType: 'sheet/updateBarriersField'
});

export default {
    name: 'QuestionsBarriers',
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        },
        endButton: {
            default: null
        }
    },
    computed: {
        ...mapFields(['needTheMost', 'workOn', 'aboutSixty', 'needOthersHelp', 'pandemic']),
        ...mapGetters('sheet', ['getFamilyBarriersQuestions'])
    },
    components: {
        ConfirmButtons
    },
    filters: {
        ...filters
    },
    mixins: [sheetValidationRules, sheetSectionsVisibility],
    methods: {
        setHasSeniors (event) {
            this.aboutSixty = event === 1;
            if (event === 1) {
                this.$store.commit('sheet/removeHiddenSelector', 'seniorPack');
                this.$store.commit('sheet/removeHiddenSelector', 'seniorReflection');
            }
            if (event === 2) {
                this.$store.commit('sheet/addHiddenSelector', 'seniorPack');
                this.$store.commit('sheet/addHiddenSelector', 'seniorReflection');
            }
        }
    }
};
</script>

<style scoped></style>
